import React from "react";

export default function PlansContainerFooter() {
  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="var_plan">
          <p>
            Unlock the full potential of your tee shirt designs with our
            flexible subscription options tailored to your unique needs. Whether
            you’re a sporadic designer or a high-volume creator.
          </p>
          <h6>Teedex has a plan for you.</h6>
        </div>
      </div>
    </div>
  );
}
